export default __webpack_public_path__ + "static/AIAGC_EXHB_3-6e2a5b7aae812f9501ef812feed0c030.jpg";